"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiForm, {
  UiFormAnnotations,
  UiFormController
} from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import i18n from "@/lang";
class AddWebPageForm extends UiFormController {
  constructor() {
    super(...arguments);
    this.web_page_name = "";
    this.web_page_url = "";
    this.web_page_platform_group = "";
    this.web_page_platform_group_second = "";
    this.web_page_description = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("add_web_pages.web_page_name_rule"),
      trigger: "blur"
    }
  ])
], AddWebPageForm.prototype, "web_page_name", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("add_web_pages.web_page_url_rule"),
      trigger: "blur"
    },
    {
      validator: (rule, value, callback) => {
        let runoob = /^(http:\/\/|https:\/\/)([a-zA-Z0-9\-\.]+)(:[0-9]+)?(\/[^\s]*)?$/;
        if (value === null || value === "") {
          callback();
          return true;
        }
        let search = value.search(runoob);
        if (search < 0) {
          callback(i18n.t("add_web_pages.add_web_page_url_incorrect"));
          return false;
        }
        callback();
        return true;
      },
      trigger: "blur"
    }
  ])
], AddWebPageForm.prototype, "web_page_url", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("add_web_pages.platform_group_rule"),
      trigger: "blur"
    }
  ])
], AddWebPageForm.prototype, "web_page_platform_group", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("add_web_pages.platform_group_rule"),
      trigger: "blur"
    }
  ])
], AddWebPageForm.prototype, "web_page_platform_group_second", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("add_web_pages.web_page_description_rule"),
      trigger: "blur"
    }
  ])
], AddWebPageForm.prototype, "web_page_description", 2);
let AddNewWebPageByHandDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.formController = new AddWebPageForm();
    this.submitLoading = false;
    this.webPagePlatformListAll = [];
    this.webPagePlatformGroup = [];
    this.webPagePlatformGroupSecond = [];
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  open() {
    return __async(this, null, function* () {
      try {
        this.dialog.visible = true;
        yield this.getPlatformGroupList();
      } catch (error) {
      }
    });
  }
  getPlatformGroupList() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(`api://base.auth/api/v1/web-resource-groups`);
        this.webPagePlatformListAll = response.data.datas;
        this.handleGroupCollapsed(response.data.datas);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //处理分离一二级分组
  handleGroupCollapsed(groups) {
    let arr = [];
    groups.forEach((item) => {
      if (item.parentId === "root") {
        arr.push(item);
      }
    });
    this.webPagePlatformGroup = arr;
  }
  //获取第二级分组列表
  changeSecondGroupsList(id) {
    let arr = [];
    this.webPagePlatformListAll.forEach((item) => {
      if (item.parentId === id) {
        arr.push(item);
      }
    });
    this.webPagePlatformGroupSecond = arr;
  }
  goBack() {
    this.formController.web_page_name = "";
    this.formController.web_page_url = "";
    this.formController.web_page_platform_group = "";
    this.formController.web_page_platform_group_second = "";
    this.formController.web_page_description = "";
    this.dialog.visible = false;
  }
  submitForm() {
    return __async(this, null, function* () {
      try {
        let submitResourceData = {
          "name": this.formController.web_page_name,
          "groupId": this.formController.web_page_platform_group_second,
          "url": this.formController.web_page_url,
          "description": this.formController.web_page_description,
          "matchRuleType": "CURRENT_PAGE",
          "shieldType": "PAGE"
        };
        let response = yield API.post(`api://base.auth/api/v1/web-resources`, submitResourceData);
        this.$message.success(this.$t("add_web_pages.add_web_resource_by_hand_success"));
        this.$emit("addByHandSuccess", response.data.id);
        this.goBack();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
AddNewWebPageByHandDialog = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit,
      UiDialog
    }
  })
], AddNewWebPageByHandDialog);
export {
  AddNewWebPageByHandDialog as default
};
